import React from 'react';
import { DashboardStats } from '../../types';

interface StatsGridProps {
  stats: DashboardStats;
}

const StatsGrid: React.FC<StatsGridProps> = ({ stats }) => {
  const statCards = [
    { icon: '📊', label: 'Total Signups', value: stats.total, color: '#3b82f6' },
    { icon: '⏳', label: 'Pending', value: stats.pending, color: '#f59e0b' },
    { icon: '✅', label: 'Approved', value: stats.approved, color: '#10b981' },
    { icon: '❌', label: 'Rejected', value: stats.rejected, color: '#ef4444' },
    { icon: '🚀', label: 'Invited', value: stats.invited || 0, color: '#3b82f6' }
  ];

  return (
    <div className="stats-grid">
      {statCards.map((card, index) => (
        <div key={index} className="stat-card">
          <div className="stat-icon">{card.icon}</div>
          <div className="stat-number">{card.value}</div>
          <div className="stat-label">{card.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;
